import classNames from "classnames";
import { FunctionComponent, useRef } from "react";
import { Icon } from "../../../../Icon";

type Props = {
  heroImages: Hero[];
  changeHandler: (event: any) => void;
  handleDelete: (imageDelete: string) => void;
  setMobileHero: React.Dispatch<React.SetStateAction<boolean>>;
};

const AdminHeroImages: FunctionComponent<Props> = ({
  heroImages,
  changeHandler,
  handleDelete,
  setMobileHero,
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const handleClick = (e: any, mobileHero: boolean) => {
    setMobileHero(mobileHero);
    if (ref.current !== null) {
      ref.current.click();
    }
  };

  const heroDesktop = heroImages.filter((img) => img.mobileHero === false);
  const heroMobile = heroImages.filter((img) => img.mobileHero === true);

  return (
    <section className="uploadImageExisting_container">
      <div className="uploadImageExisting">
        <h3>Desktop</h3>
        <div className="uploadImageImage_container">
          {heroDesktop.map((img) => {
            return (
              <div className="uploadImageImage" key={img.urlImage}>
                <img src={img.urlImage} className="imgThumbnail"></img>
                <div className="uploadImageControls">
                  <div onClick={() => handleDelete(img.key)}>
                    <Icon iconName="trash_cart" className="uploadImageButton" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="uploadImage">
          <input
            type="file"
            name="file"
            ref={ref}
            onChange={changeHandler}
            style={{ display: "none" }}
          />

          <button
            type="button"
            onClick={(e) => handleClick(e, false)}
            className={classNames("uploadImage__button")}
          >
            Subir imagen
          </button>
        </div>
      </div>
      <div className="uploadImageExisting">
        <h3>Mobile</h3>
        <div className="uploadImageImage_container">
          {heroMobile.map((img) => {
            return (
              <div className="uploadImageImage" key={img.key}>
                <img src={img.urlImage} className="imgThumbnail"></img>
                <div className="uploadImageControls">
                  <div onClick={() => handleDelete(img.key)}>
                    <Icon iconName="trash_cart" className="uploadImageButton" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="uploadImage">
          <input
            type="file"
            name="file"
            ref={ref}
            onChange={changeHandler}
            style={{ display: "none" }}
          />

          <button
            type="button"
            onClick={(e) => handleClick(e, true)}
            className={classNames("uploadImage__button")}
          >
            Subir imagen
          </button>
        </div>
      </div>
    </section>
  );
};

export default AdminHeroImages;
